// Composes individual schema.org node builders into a single @graph.

import type { ResolvedSEO, SEOProps } from '../types';
import { buildArticle } from './article';
import { buildBreadcrumbList } from './breadcrumbList';
import { buildFAQPage } from './faqPage';
import { buildOrganization } from './organization';
import { buildSoftwareApplication } from './softwareApplication';
import { buildVideoGame } from './videoGame';
import { buildWebPage } from './webPage';
import { buildWebSite } from './website';

export const buildGraph = (resolved: ResolvedSEO, props: SEOProps) => {
  const { url, description, image, isHomePage } = resolved;
  const nodes = [
    buildOrganization(),
    buildWebSite(description),
    buildSoftwareApplication({ isHomePage, description, image }),
    buildWebPage(resolved),
    buildArticle({ url, articleData: props.articleData }),
    buildBreadcrumbList({ url, breadcrumbs: props.breadcrumbs }),
    buildFAQPage({ url, faqItems: props.faqItems }),
    buildVideoGame({ url, gameData: props.gameData }),
  ].filter((node): node is NonNullable<typeof node> => node !== null);

  return {
    '@context': 'https://schema.org',
    '@graph': nodes,
  };
};
